import React, { useEffect, useState } from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { F0Icon, type IconType } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp } from '@factorialco/f0-react/icons/app'
import { AnimatePresence } from 'framer-motion'

interface Props {
  collapsedTitle: string
  expandedTitle: string
  divider?: boolean
  collapsible?: boolean
  children: React.ReactNode
  defaultCollapsed?: boolean
  noGap?: boolean
  /** Icon shown to the left of the title (e.g. for "See full breakdown") */
  titleIcon?: IconType
}

const FormBlock = ({
  collapsedTitle,
  expandedTitle,
  divider = true,
  collapsible = false,
  defaultCollapsed = false,
  children,
  noGap = false,
  titleIcon: TitleIcon,
}: Props) => {
  const [open, setOpen] = useState(!defaultCollapsed)

  useEffect(() => {
    setOpen(!defaultCollapsed)
  }, [defaultCollapsed])

  const title = open ? expandedTitle : collapsedTitle

  return (
    <Box gap={noGap ? 's0' : 's16'}>
      <Box
        onClick={() => setOpen(!open)}
        aria-label={'See full breakdown'}
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box flexDirection="row" alignItems="center" gap="s8" paddingTop="s6">
          {TitleIcon != null && <F0Icon size="lg" icon={TitleIcon} aria-hidden />}
          <Text.Normal size="200" weight="medium" color="grey1000">
            {title}
          </Text.Normal>
        </Box>

        {collapsible && <F0Icon size="lg" icon={open ? ChevronUp : ChevronDown} />}
      </Box>

      <Box paddingY="s12">
        <Divider vertical={false} />
      </Box>
      <AnimatePresence>
        {(!collapsible || open) && (
          <Box.Motion
            flexDirection="column"
            gap="s16"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            {children}
          </Box.Motion>
        )}
      </AnimatePresence>
      {divider && (
        <Box paddingTop="s16" paddingBottom="s16">
          <Divider vertical={false} />
        </Box>
      )}
    </Box>
  )
}

export default FormBlock
